import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {VkService} from './vk.service';
import {AllService} from '../../services/all.service';
import {log} from '../../functions';
import {debounceTime, delay} from 'rxjs/operators';
import {ReplaySubject, throttleTime} from 'rxjs';
import {VkApiError, VkApiMessagesGetById} from './vk.types';
import {NotifierWrapService} from '../../services/notifier-wrap.service';

@Injectable({
  providedIn: 'root'
})
export class VkLongPullService {
  private server: string;
  private key: string;
  private ts: number;
  private lastPool: number;
  public pull$: ReplaySubject<string> = new ReplaySubject();
  public initPullServer$: ReplaySubject<void> = new ReplaySubject();

  pullInterval = 5;

  constructor(
    private vkService: VkService,
    private allService: AllService,
    public notifierWrapService: NotifierWrapService,
    private http: HttpClient) {
    // this.initPullServer();
    /*
    this.vkService.VK.Api.call('messages.getLongPollServer', {need_pts: 1, lp_version: 3, v:"5.73"}, (r) => {
      log('getLongPollServer')
      if (r.response) {
        this.server = r.response.server;
        this.key = r.response.key;
        this.ts = r.response.ts;
        this.pull$.next();
      }
    });*/
    this.pull$.pipe(debounceTime(1500))
      .subscribe((initiator) => {
        // log('Pull: ' + initiator);
        this.pull();
      });
    this.initPullServer$.pipe(throttleTime(3000))
      .subscribe((initiator) => {
        this.initPullServer();
      });
  }

  initPullServer() {
    if (this.vkService.isAuth) {
      const vkUrl = `https://api.vk.com/method/messages.getLongPollServer?access_token=${this.vkService.token}&lp_version=3&need_pts=1&v=${this.vkService.apiVersion}&lp_version=12`;
      this.allService
        .crossDomainRequest(vkUrl)
        .subscribe(
          (r: any) => {
            log('initPullServer', r);
            if (r.response) {
              this.allService.vkDisconnect = false;
              this.server = r.response.server;
              this.key = r.response.key;
              this.ts = r.response.ts;

              this.allService.setCookie('vk_server', this.server, {expires: 99999999});
              this.allService.setCookie('vk_key', this.key, {expires: 99999999});
              this.allService.setCookie('vk_ts', this.ts, {expires: 99999999});

              this.reconnectInit();
              this.pull$.next('initPullServer');
            } else if (r?.error?.error_code === 5) {
              this.vkService.logout();
              this.notifierWrapService.notify('error', 'Вам необходимо авторизоваться.');
            } else {
              this.allService.vkDisconnect = true;
              setTimeout(() => {
                this.initPullServer$.next();
              }, 5000);
            }
          },
          (error) => {
          }
        );
    }
  }


  reconnectInit() {
    setInterval(() => {
      if (this.vkService.isAuth && this.lastPool && this.lastPool < Date.now() - 61 * 1000) {
        // alert('reconnectInit');
        this.pull$.next('reconnectInit');
      }
    }, 3000);
  }

  pull() {
    this.lastPool = Date.now();
    const vkUrl = `https://${this.server}?act=a_check&key=${this.key}&ts=${this.ts}&wait=${this.pullInterval}&mode=2&version=3`;
    // log('getLongPollServer pull' + vkUrl)
    this.allService
      .crossDomainRequest(vkUrl)
      .subscribe(
        (res: any) => {
          // log('getLongPollServer res: ' + res)
          if (this.allService._vkDisconnect) {
            this.allService.vkDisconnect = false;
          }

          if (res?.updates) {
            res.updates.forEach((event) => {
              const action_code = event[0];
              switch (action_code) {
                case 4:
                  const id = event[1];
                  // const chat_id = event[3];

                  const summa = []; // массив, где мы будем хранить слагаемые
                  const flag = event[2]; // флаг сообщения
                  [1, 2, 4, 8, 16, 32, 64, 128, 256, 512, 65536].forEach((number) => {
                    // проходим циклом по возможным слагаемым
                    if (flag & number) {
                      // проверяем, является ли число слагаемым с помощью побитового И
                      summa.push(number); // # если является, добавляем его в массив
                    }
                  });
                  // if (!summa.includes(2)){
                  this.vkService.VK.Api.call('messages.getById', {
                    message_ids: id,
                    extended: 1,
                    v: '5.92'
                  }, (res: { response: VkApiMessagesGetById } | VkApiError) => {
                    if (res.response) {
                      // TODO!!!
                      const arMessage = this.vkService.messageRender(res.response.items[0], res.response, false);
                      this.allService.wsService.wsMessages$.next({
                        event: 'new_message',
                        type: 'vk',
                        data: {
                          path: 'vk',
                          new_message: arMessage
                        }
                      });
                    }
                  });
                  // }
                  break;
                case 5:
                  this.vkService.VK.Api.call(
                    'messages.getById',
                    {message_ids: event[1], extended: 1, v: '5.92'},
                    (res: { response: VkApiMessagesGetById } | VkApiError) => {
                      if (res.response) {
                        const arMessage = this.vkService.messageRender(res.response.items[0], res.response);
                        arMessage.chat_id = event[3];
                        this.allService.wsService.wsMessages$.next({
                          event: 'edit_message',
                          type: 'vk',
                          data: {
                            path: 'vk',
                            edit_message: arMessage
                          }
                        });
                      }
                    }
                  );
                  break;
                // case 6:
                case 7:
                  this.allService.wsService.wsMessages$.next({
                    event: 'read',
                    type: 'vk',
                    data: {
                      path: 'vk',
                      chat_id: event[1],
                      max_id: event[2]
                    }
                  });
                  break;
                // Offline, Online
                case 8:
                case 9:
                  this.allService.wsService.wsMessages$.next({
                    event: 'online',
                    type: 'vk',
                    data: {
                      path: 'vk',
                      online: action_code === 8,
                      user_id: event[1],
                      last_seen: {time: event[2]}
                    }
                  });
                  break;
                case 61:
                // TODO
                case 62:
                  this.allService.wsService.wsMessages$.next({
                    event: 'typing',
                    type: 'vk',
                    data: {
                      path: 'vk',
                      typing: true,
                      user_id: event[1]
                    }
                  });
                  break;
              }
            });
            this.setTs(res?.ts);
          } else if (res?.failed) {
            this.initPullServer$.next();
            return;
          }
          this.setTs(res?.ts);
          setTimeout(() => {
            this.pull$.next('pull');
          }, 5000);

        },
        (error) => {
          this.allService.vkDisconnect = true;
          log('error!!!!!!!!');
          log(error);
          setTimeout(() => {
            this.pull$.next('pull:error');
          }, 5000);
        }
      );
  }

  setTs(ts: number | undefined) {
    if (ts) {
      this.ts = ts;
      this.allService.setCookie('vk_ts', ts, {expires: 99999999});
    }
  }
}
